import React from 'react';
import DataTables from '../../CommonDataTable/DataTable';
import config from '../../../../config/config';
import apiCalls from '../../../../config/apiCalls'
import ViewModal from '../../CommonModals/viewModal';
import NewUserModal from '../../CommonModals/NewUserModal';
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage';

import fetchMethodRequest from "../../../../config/service"
import FormModal from '../../../Form/FormModal';
import store from '../../../App/store';
import filePath from "../../../../config/configSampleFiles";

import RolePermissions from '../../CommonModals/Permissions';

import AppointmentDashboard from '../AppointmentDashboard';
// config file
export default class Teachers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageData: '',
      rolePermission: "",
      editSelectedRecord:window.location.href.includes("edit"),
      addSelectedRecord:window.location.href.includes("create"),
      viewSelectedRecord:window.location.href.includes("view"),	
    };
  }

  static getDerivedStateFromProps(props, state) {
    let storeData = store.getState()
    let languageData = storeData && storeData.settingsData && storeData.settingsData.settings && storeData.settingsData.settings.languageTranslation ? storeData.settingsData.settings.languageTranslation : ""
    return { languageData: languageData };
  }
  componentDidMount = () => {
    //Screen permisions value can be edit,view, no view
    let screenPermissions = RolePermissions.screenPermissions('Appointments');
    if (screenPermissions) {
      this.setState({
        rolePermission: screenPermissions
      })
    }
  }

  setData = (props) => {
    let rowData = {}
    // console.log(props.match)
    if (props && props.match && props.match.params && props.match.params.id) {
      rowData["_id"] = JSON.parse(props.match.params.id)
      return rowData
    }
  }
  getTableFields = () => {
    let { languageData } = this.state
    let roleTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Admin',
        value: 'Admin'
      },
      {
        label: 'Super Admin',
        value: 'Super Admin'
      },
      {
        label: 'User',
        value: 'User'
      },
    ];
    let StatusTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      }
    ];
    let data = [     
      {
        "textAlign": "center",
        "width": 47,
        "field": "Check Box",
        "label": "Check Box",
        "fieldType": "multiple",
        "header": "",
        "selectionMode": "multiple",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "textAlign": "center",
        "width": 50,
        "field": "Sno",
        "label": "SNo",
        "header": "SNo",
        "filter": false,
        "sortable": false,
        "placeholder": "Search",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
     
      // {
      //   "name": "name",
      //   "type": "text",
      //   "placeholder": "Name",
      //   "label": "Name",
      //   "width": 110,
      //   "header": "Name",
      //   "derivedValue": "name=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": true,
      //   "filter": true,
      //   "id": "name",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "required": false,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "name",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true,
      //   "fieldType": "Link",
      //   "style": {
      //     "color": "#0e4768",
      //     "cursor": "pointer",
      //     "textTransform": "capitalize"
      //   }
      // },
      {
        "name": "patient",
        "type": "text",
        "placeholder": "Patient",
        "label": "Patient",
        "width": "150px",
        "header": "Patient",
        "derivedValue": "patient=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "patient",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1012,               
        "controllerName": "patients",        
        "isMultiple": false,
        "textAlign": "Center",
        "fieldType": "Link",
        "show": true,
        "field": "patientName",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "viewLink":true,
         "filter":true 
         
      },
      {
        "name": "slotFromTime",
        "type": "text",
        "placeholder": "From Time",
        "label": "slotFromTime",
        "width": "120px",
        "header": "From Time",
        "derivedValue": "patient=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "patient",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1012,               
        "controllerName": "patients",        
        "isMultiple": false,
        "textAlign": "Center",
        "fieldType": "text",
        "show": true,
        "field": "slotFromTime",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,       
         "filter":true 
         
      },
      {
        "name": "slotToTime",
        "type": "text",
        "placeholder": "To Time",
        "label": "slotToTime",
        "width": "120px",
        "header": "To Time",
        "derivedValue": "patient=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "patient",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1012,               
        "controllerName": "patients",        
        "isMultiple": false,
        "textAlign": "Center",
        "fieldType": "text",
        "show": true,
        "field": "slotToTime",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,        
         "filter":true 
         
      }, 
      {
        "name": "scheduledDate",
        "type": "date",
        "placeholder": "Scheduled",
        "label": "Scheduled",
        "width": "120px",
        "header": "Scheduled Date",
        "derivedValue": "nextAppointment=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "scheduledDate",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "field": "scheduledDate",
        "showOrHideFields": [],
        "mobile": true,
        "filter":true , 
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true,
        "rowEditor":true
      },     
      {
        "name": "provider",
        "type": "text",
        "placeholder": "Provider",
        "label": "Provider",
        "width": "150px",
        "header": "Provider",
        "derivedValue": "provider=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "provider",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1010,       
        "textAlign": "Center",
        "show": true,
        "filter":true , 
        "field": "providerName",
        "showOrHideFields": [],
        "fieldName": "providerName",
        "mobile": true,
        "displayInSettings": true,
        "filter":true  
      },
     
      // {
      //   "name": "providers_name",
      //   "type": "text",
      //   "placeholder": "providers_name",
      //   "label": "providers_name",
      //   "header": "providers name",
      //   "width": 110,
      //   "parentField": "provider",
      //   "id": "providers_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "providers_name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "scanCptCode",
      //   // "type": "relateAutoComplete",
      //   "placeholder": "Scan cpt  code",
      //   "label": "Scan cpt code",
      //   "width": "150px",
      //   "header": "Scan cpt code",
      //   "derivedValue": "scanCptCode=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "filter": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "scanCptCode",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "true",
      //   "required": true,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "scans",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true,
      //   "searchField": "cptCode",
      //   // "isMultiple":true,
      //   // "fieldType":"relateAutoComplete"
      // },
      {
        "name": "scanCptCode",
        "type": "text",
        "placeholder": "Procedure  code",
        "label": "Procedure code",
        "width": "150px",
        "header": "Procedure code",
        "derivedValue": "scanCptCode=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": false,
        "actions": [],
        "actionsNumber": [],
        "id": "scanCptCode",
        "displayinlist": "true",
        "fieldType": "text",
        "textAlign": "Center",
        "subFieldName": "name",
        "show": true,
        "filter":true , 
        "field": "scanCptCode",
        "mobile": true,
        "displayInSettings": true,
        "searchField": "cptCode",
        "filter":true
        
      },
      {
        "name": "scanDescription",
        "type": "text",
        "placeholder": "Procedure",
        "label": "Procedure",
        "header": "Procedure",
        "width": "250px",
        "parentField": "scans",
        "id": "scanDescription",
        "displayinlist": "true",        
        "textAlign": "Center",
        "subFieldName": "description",
        "show": true,
        "filter":true , 
        "field": "scanDescription",
        "mobile": true,
        "displayInSettings": true,
        "filter":true,
        "sortable": true
      }, 
      // {
      //   "name": "facility",
      //   "type": "relateAutoComplete",
      //   "placeholder": "Facility",
      //   "label": "Facility",
      //   "width": "90px",
      //   "header": "Facility",
      //   "derivedValue": "facility=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "facility",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "false",
      //   "controllerId": 1011,
      //   "searchField": "name",
      //   "fieldType": "relateAutoComplete",
      //   "populteFields": [],
      //   "displayFields": [
      //     "name"
      //   ],
      //   "controllerName": "facilities",
      //   "searchApi": "facilitiess",
      //   "isMultiple": false,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "facility",
      //   "showOrHideFields": [],
      //   "fieldName": "facility",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "facilities_name",
      //   "type": "text",
      //   "placeholder": "facilitie name",
      //   "label": "facilities_name",
      //   "header": "facilities name",
      //   "width": 110,
      //   "parentField": "facility",
      //   "id": "facilities_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "facilityName",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
    
      
      
      {
        "name": "facilityStaff",
        "type": "text",
        "placeholder": "Facility Staff",
        "label": "Facility Staff",
        "width": "150px",
        "addFormOrder": 18,
        "editFormOrder": 18,
        "header": "Facility Staff",
        "derivedValue": "facilityStaff=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "facilityStaff",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1009,      
        "isMultiple": false,
        "textAlign": "Center",
        "show": true,
        "field": "facilityStaffName",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true,        
      },
      // {
      //   "name": "facilityemployee_name",
      //   "type": "text",
      //   "placeholder": "facilityemployee_name",
      //   "label": "facilityemployee_name",
      //   "header": "facilityemployee name",
      //   "width": 110,
      //   "parentField": "facilityStaff",
      //   "id": "facilityemployee_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "facilityemployee_name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "status",
        "type": "dropDown",
        "placeholder": "Status",
        "label": "Status",
        "width": "150px",
        "addFormOrder": 19,
        "editFormOrder": 19,
        "header": "Status",
        "derivedValue": "status=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "status",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "options": [
          {
            "label": "Created",
            "value": "Created",
            "color": "primary"
          },
          {
            "label": "Assigned",
            "value": "Assigned",
            "color": "primary"
          },
          {
            "label": "Scheduled",
            "value": "Scheduled",
            "color": "primary"
          },
          {
            "label": "Scan Done",
            "value": "Scan Done",
            "color": "primary"
          },
          {
            "label": "Reviewed",
            "value": "Reviewed",
            "color": "primary"
          },
          {
            "label": "Complete",
            "value": "Complete",
            "color": "primary"
          },
          {
            "label": "Notify Dr",
            "value": "Notify Dr",
            "color": "primary"
          }
        ],
        "fieldType": "dropDown",
        "filterElement": [
          {
            "label": "Created",
            "value": "Created",
            "color": "primary"
          },
          {
            "label": "Assigned",
            "value": "Assigned",
            "color": "primary"
          },
          {
            "label": "Scheduled",
            "value": "Scheduled",
            "color": "primary"
          },
          {
            "label": "Scan Done",
            "value": "Scan Done",
            "color": "primary"
          },
          {
            "label": "Reviewed",
            "value": "Reviewed",
            "color": "primary"
          },
          {
            "label": "Complete",
            "value": "Complete",
            "color": "primary"
          },
          {
            "label": "Notify Dr",
            "value": "Notify Dr",
            "color": "primary"
          }
        ],
        "dependent": [],
        "textAlign": "Center",
        "show": true,
        "field": "status",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "rowEditor":true
      },
      {
        "name": "note",
        "type": "text",
        "placeholder": "Note",
        "label": "Note",
        "width": "300px",
        "header": "Note",
        "derivedValue": "note=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "note",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "note",
        "filter":true , 
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true  
      },
      {
        "name": "financialClass",
        "type": "dropDown",
        "placeholder": "Select",
        "label": "Financial Class",
        "width": "140px",
        "header": "Financial Class",
        "derivedValue": "financialClass=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "financialClass",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1012,               
        "controllerName": "financialClass",        
        "isMultiple": false,
        "textAlign": "Center",
        "fieldType": "dropDown",
        "show": true,
        "field": "financialClass",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,        
         "filter":true,
         "filterElement": [
          {
            "label": "Managed Care",
            "value": "Managed Care",
            "color": "primary"
          },
          {
            "label": "Medicaid",
            "value": "Medicaid",
            "color": "primary"
          },
          {
            "label": "Medicare",
            "value": "Medicare",
            "color": "primary"
          }, 
          {
            "label": "No Charge",
            "value": "No Charge",
            "color": "primary"
          },    
          {
            "label": "PIP",
            "value": "PIP",
            "color": "primary"
          },
          {
            "label": "Self Pay",
            "value": "Self Pay",
            "color": "primary"
          },
          {
            "label": "Slip & Fall",
            "value": "Slip & Fall",
            "color": "primary"
          },
          {
            "label": "Workmans Comp",
            "value": "Workmans Comp",
            "color": "primary"
          }    
        ],         
      },
      {
        "name": "dateOfInjury",
        "type": "date",
        "placeholder": "Date Of Injury",
        "label": "Date Of Injury",
        "width": "140px",
        "header": "Date Of Injury",
        "derivedValue": "dateOfInjury=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "dateOfInjury",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "filter":true , 
        "field": "dateOfInjury",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true  
      },
      {
        "name": "policyNumber",
        "type": "text",
        "placeholder": "Policy Number",
        "label": "Policy Number",
        "width": "130px",
        "header": "Policy Number",
        "derivedValue": "policyNumber=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "policyNumber",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "policyNumber",
        "filter":true , 
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true  
      },
      {
        "name": "nextAppointment",
        "type": "date",
        "placeholder": "Next Appointment Date",
        "label": "Next Appointment Date",
        "width": "160px",
        "header": "Next Appointment Date",
        "derivedValue": "nextAppointment=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "nextAppointment",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "filter":true , 
        "field": "nextAppointment",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true  
      },
   
      {
        "name": "scannedDate",
        "type": "date",
        "placeholder": "Scanned",
        "label": "Scanned",
        "width": "120px",
        "header": "Scanned Date",
        "derivedValue": "nextAppointment=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "scannedDate",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "field": "scannedDate",
        "showOrHideFields": [],
        "mobile": true,
        "filter":true , 
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true  
      },
      {
        "name": "reviewedDate",
        "type": "date",
        "placeholder": "reviewedDate",
        "label": "reviewedDate",
        "width": "120px",
        "header": "Reviewed Date",
        "derivedValue": "reviewedDate=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "scannedDate",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "field": "reviewedDate",
        "showOrHideFields": [],
        "mobile": true,
        "filter":true , 
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true  
      },
      {
        "name": "completedDate",
        "type": "date",
        "placeholder": "CompletedDate",
        "label": "Completed Date",
        "width": "120px",
        "header": "Completed Date",
        "derivedValue": "completedDate=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "completedDate",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "field": "completedDate",
        "showOrHideFields": [],
        "mobile": true,
        "filter":true , 
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true  
      },

      {
        "name": "notifiedDate",
        "type": "date",
        "placeholder": "notifiedDate",
        "label": "Notified Date",
        "width": "120px",
        "header": "Notified Date",
        "derivedValue": "notifiedDate=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "notifiedDate",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "filter":true , 
        "field": "notifiedDate",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true  
      },
     
      {
        "name": "physician",
        "type": "text",
        "placeholder": "Physician",
        "label": "Physician",
        "width": "120px",
        "addFormOrder": 17,
        "editFormOrder": 17,
        "header": "Physician",
        "derivedValue": "physician=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "physician",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1008,       
        "isMultiple": false,
        "filter":true , 
        "textAlign": "Center",
        "show": true,
        "field": "physicianName",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true  
      },
      // {
      //   "name": "hospitalemployee_Name",
      //   "type": "text",
      //   "placeholder": "hospitalemployee_Name",
      //   "label": "hospitalemployee_Name",
      //   "header": "hospitalemployee Name",
      //   "width": 110,
      //   "parentField": "physician",
      //   "id": "hospitalemployee_Name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "Name",
      //   "show": true,
      //   "field": "hospitalemployee_Name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "phoneNumber",
        "type": "text",
        "placeholder": "Phone Number",
        "label": "Phone Number",
        "width": "150px",
        "header": "Phone Number",
        "derivedValue": "phoneNumber=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "phoneNumber",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "filter":true , 
        "field": "phoneNumber",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true  
      },
      {
        "name": "speciality",
        "type": "text",
        "placeholder": "Speciality",
        "label": "Speciality",
        "width": "90px",
        "header": "Speciality",
        "derivedValue": "speciality=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "speciality",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "filter":true , 
        "field": "speciality",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true  
      },
      {
        "name": "Npi",
        "type": "text",
        "placeholder": "NPI",
        "label": "NPI",
        "width": "90px",
        "header": "NPI",
        "derivedValue": "Npi=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "Npi",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "filter":true , 
        "field": "Npi",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true  
      },
      {
        "name": "fax",
        "type": "text",
        "placeholder": "Fax",
        "label": "Fax",
        "width": "150px",
        "header": "Fax",
        "derivedValue": "fax=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "fax",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "filter":true , 
        "field": "fax",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true  
      },
      // {
      //   "name": "address",
      //   "type": "textarea",
      //   "placeholder": "Address",
      //   "label": "Address",
      //   "width": "90px",
      //   "header": "Address",
      //   "derivedValue": "address=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "address",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "address",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "createdByName",
        "type": "Text",
        "placeholder": "Created By",
        "label": "Created By",
        "width": 120,
        "header": "Created By",
        "id": "createdByName",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "field": "createdByName",
        "mobile": true,
        "filter": true,
        "displayInSettings": true
      },
      {
        "name": "updatedByName",
        "type": "Text",
        "placeholder": "Updated By",
        "label": "Updated By",
        "width": 120,
        "header": "Updated By",
        "id": "updatedByName",
        "displayinlist": "true",
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "filter": true,
        "field": "updatedByName",
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": 150,
        "header": "Updated",
        "derivedValue": "updated=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "updated",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "updated",
        "mobile": true,
        "filter":true , 
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true ,
        "sortable": true 
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": 150,
        "header": "Created",
        "derivedValue": "created=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "created",
        "mobile": true,
        "filter":true , 
        "displayInSettings": true,
        "fieldType": "date",
        "filter":true  ,
        "sortable": true
      },   
     
    ]
    data.push(  {
      "show": true,
      "textAlign": "center",
      "width": 60,
      "fieldType": "rowEdit",
      "field": "rowEdit",
      "header": "",
      "filter": false,
      "sortable": false,

    })
    return data;
  };

  getFormFields = () => {
    let { languageData } = this.state
    let statusTypes = [
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      },
    ];
    return (
      [
        {
          "name": "patientName",
          "type": "text",
          "placeholder": "Patient",
          "label": "Patient",
          "width": "150px",
          "header": "Patient",
          "derivedValue": "patient=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "patient",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": 1012,               
          "controllerName": "patients",        
          "isMultiple": false,
          "textAlign": "Center",
          "fieldType": "Link",
          "show": true,
          "disable":true,
          "field": "patientName",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "viewLink":true,
           "filter":true 
           
        },
        {
          "name": "slotFromTime",
          "type": "text",
          "placeholder": "From Time",
          "label": "slotFromTime",
          "width": "120px",
          "header": "From Time",
          "derivedValue": "patient=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "patient",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": 1012,               
          "controllerName": "patients",        
          "isMultiple": false,
          "textAlign": "Center",
          "fieldType": "text",
          "show": true,
          "disable":true,
          "field": "slotFromTime",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,       
           "filter":true 
           
        },
        {
          "name": "slotToTime",
          "type": "text",
          "placeholder": "To Time",
          "label": "slotToTime",
          "width": "120px",
          "header": "To Time",
          "derivedValue": "patient=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "patient",
          "disable":true,
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": 1012,               
          "controllerName": "patients",        
          "isMultiple": false,
          "textAlign": "Center",
          "fieldType": "text",
          "show": true,
          "field": "slotToTime",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,        
           "filter":true 
           
        }, 
        {
          "name": "scheduledDate",
          "type": "date",
          "placeholder": "Scheduled",
          "label": "Scheduled",
          "width": "120px",
          "header": "Scheduled Date",
          "derivedValue": "nextAppointment=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "disable":true,
          "actionsNumber": [],
          "id": "scheduledDate",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": null,
          "dateFormat": "DD-MM-YYYY",
          "textAlign": "Center",
          "show": true,
          "field": "scheduledDate",
          "showOrHideFields": [],
          "mobile": true,
          "filter":true , 
          "displayInSettings": true,
          "fieldType": "date",
          "filter":true,
          "rowEditor":true
        },     
        {
          "name": "providerName",
          "type": "text",
          "placeholder": "Provider",
          "label": "Provider",
          "width": "150px",
          "header": "Provider",
          "derivedValue": "provider=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "disable":true,
          "actionsNumber": [],
          "id": "provider",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": 1010,       
          "textAlign": "Center",
          "show": true,
          "filter":true , 
          "field": "providerName",
          "showOrHideFields": [],
          "fieldName": "providerName",
          "mobile": true,
          "displayInSettings": true,
          "filter":true  
        },
        {
          "name": "scanCptCode",
          "type": "text",
          "placeholder": "Scan cpt  code",
          "label": "Scan cpt code",
          "width": "150px",
          "header": "Scan cpt code",
          "derivedValue": "scanCptCode=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "filter": false,
          "actions": [],
          "disable":true,
          "actionsNumber": [],
          "id": "scanCptCode",
          "displayinlist": "true",
          "fieldType": "text",
          "textAlign": "Center",
          "subFieldName": "name",
          "show": true,
          "filter":true , 
          "field": "scanCptCode",
          "mobile": true,
          "displayInSettings": true,
          "searchField": "cptCode",
          "filter":true
          
        },
        {
          "name": "scanDescription",
          "type": "text",
          "placeholder": "scanDescription",
          "label": "Scan Description",
          "header": "Scan Description",
          "width": "250px",
          "parentField": "scans",
          "id": "scanDescription",
          "displayinlist": "true",        
          "textAlign": "Center",
          "subFieldName": "description",
          "show": true,
          "disable":true,
          "filter":true , 
          "field": "scanDescription",
          "mobile": true,
          "displayInSettings": true,
          "filter":true,
          "sortable": true
        }, 
        
        {
          "name": "facilityStaffName",
          "type": "text",
          "placeholder": "Facility Staff",
          "label": "Facility Staff",
          "width": "150px",
          "addFormOrder": 18,
          "editFormOrder": 18,
          "header": "Facility Staff",
          "derivedValue": "facilityStaff=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "facilityStaff",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": 1009,      
          "isMultiple": false,
          "textAlign": "Center",
          "show": true,
          "disable":true,
          "field": "facilityStaffName",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "filter":true,        
        },
      
        {
          "name": "status",
          "type": "dropDown",
          "placeholder": "Status",
          "label": "Status",
          "width": "150px",
          "addFormOrder": 19,
          "editFormOrder": 19,
          "header": "Status",
          "derivedValue": "status=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "filter": true,
          "actions": [],
          "actionsNumber": [],
          "id": "status",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "true",
          "required": true,
          "displayOptionsInActions": false,
          "globalSearchField": "true",
          "controllerId": null,
          "options": [
            {
              "label": "Created",
              "value": "Created",
              "color": "primary"
            },
            {
              "label": "Assigned",
              "value": "Assigned",
              "color": "primary"
            },
            {
              "label": "Scheduled",
              "value": "Scheduled",
              "color": "primary"
            },
            {
              "label": "Scan Done",
              "value": "Scan Done",
              "color": "primary"
            },
            {
              "label": "Reviewed",
              "value": "Reviewed",
              "color": "primary"
            },
            {
              "label": "Complete",
              "value": "Complete",
              "color": "primary"
            },
            {
              "label": "Notify Dr",
              "value": "Notify Dr",
              "color": "primary"
            }
          ],
          "fieldType": "dropDown",
          "filterElement": [
            {
              "label": "Created",
              "value": "Created",
              "color": "primary"
            },
            {
              "label": "Assigned",
              "value": "Assigned",
              "color": "primary"
            },
            {
              "label": "Scheduled",
              "value": "Scheduled",
              "color": "primary"
            },
            {
              "label": "Scan Done",
              "value": "Scan Done",
              "color": "primary"
            },
            {
              "label": "Reviewed",
              "value": "Reviewed",
              "color": "primary"
            },
            {
              "label": "Complete",
              "value": "Complete",
              "color": "primary"
            },
            {
              "label": "Notify Dr",
              "value": "Notify Dr",
              "color": "primary"
            }
          ],
          "dependent": [],
          "textAlign": "Center",
          "show": true,
          "field": "status",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "rowEditor":true
        },
        {
          "name": "note",
          "type": "text",
          "placeholder": "Note",
          "label": "Note",
          "width": "300px",
          "header": "Note",
          "derivedValue": "note=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "note",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "true",
          "controllerId": null,
          "textAlign": "Center",
          "show": true,
          "field": "note",
          "filter":true , 
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "filter":true  
        },
        {
          "name": "nextAppointment",
          "type": "date",
          "placeholder": "Next Appointment",
          "label": "Next Appointment",
          "width": "120px",
          "header": "Next Appointment",
          "derivedValue": "nextAppointment=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "nextAppointment",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": null,
          "dateFormat": "DD-MM-YYYY",
          "textAlign": "Center",
          "show": true,
          "filter":true ,
          "disable":true, 
          "field": "nextAppointment",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "fieldType": "date",
          "filter":true  
        },
     
        {
          "name": "scannedDate",
          "type": "date",
          "placeholder": "Scanned Date",
          "label": "Scanned Date",
          "width": "120px",
          "header": "Scanned Date",
          "derivedValue": "nextAppointment=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "scannedDate",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": null,
          "dateFormat": "DD-MM-YYYY",
          "textAlign": "Center",
          "show": true,
          "field": "scannedDate",
          "showOrHideFields": [],
          "mobile": true,
          "filter":true , 
          "displayInSettings": true,
          "fieldType": "date",
          "filter":true  
        },
        {
          "name": "reviewedDate",
          "type": "date",
          "placeholder": "reviewedDate",
          "label": "reviewedDate",
          "width": "120px",
          "header": "Reviewed Date",
          "derivedValue": "reviewedDate=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "scannedDate",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": null,
          "dateFormat": "DD-MM-YYYY",
          "textAlign": "Center",
          "show": true,
          "field": "reviewedDate",
          "showOrHideFields": [],
          "mobile": true,
          "filter":true , 
          "displayInSettings": true,
          "fieldType": "date",
          "filter":true  
        },
        {
          "name": "completedDate",
          "type": "date",
          "placeholder": "CompletedDate",
          "label": "Completed Date",
          "width": "120px",
          "header": "Completed Date",
          "derivedValue": "completedDate=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "completedDate",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": null,
          "dateFormat": "DD-MM-YYYY",
          "textAlign": "Center",
          "show": true,
          "field": "completedDate",
          "showOrHideFields": [],
          "mobile": true,
          "filter":true , 
          "displayInSettings": true,
          "fieldType": "date",
          "filter":true  
        },
  
        {
          "name": "notifiedDate",
          "type": "date",
          "placeholder": "notifiedDate",
          "label": "Notified Date",
          "width": "120px",
          "header": "Notified Date",
          "derivedValue": "notifiedDate=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "notifiedDate",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": null,
          "dateFormat": "DD-MM-YYYY",
          "textAlign": "Center",
          "show": true,
          "filter":true , 
          "field": "notifiedDate",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "fieldType": "date",
          "filter":true  
        },
       
        {
          "name": "physicianName",
          "type": "text",
          "placeholder": "Physician",
          "label": "Physician",
          "width": "120px",
          "addFormOrder": 17,
          "editFormOrder": 17,
          "header": "Physician",
          "derivedValue": "physician=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "physician",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "false",
          "controllerId": 1008,    
          "disable":true,   
          "isMultiple": false,
          "filter":true , 
          "textAlign": "Center",
          "show": true,
          "field": "physicianName",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "filter":true  
        },
        // {
        //   "name": "hospitalemployee_Name",
        //   "type": "text",
        //   "placeholder": "hospitalemployee_Name",
        //   "label": "hospitalemployee_Name",
        //   "header": "hospitalemployee Name",
        //   "width": 110,
        //   "parentField": "physician",
        //   "id": "hospitalemployee_Name",
        //   "displayinlist": "true",
        //   "fieldType": "RACSubField",
        //   "textAlign": "Center",
        //   "subFieldName": "Name",
        //   "show": true,
        //   "field": "hospitalemployee_Name",
        //   "mobile": true,
        //   "displayInSettings": true
        // },
        {
          "name": "phoneNumber",
          "type": "text",
          "placeholder": "Phone Number",
          "label": "Phone Number",
          "width": "150px",
          "header": "Phone Number",
          "derivedValue": "phoneNumber=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "phoneNumber",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "true",
          "controllerId": null,
          "textAlign": "Center",
          "show": true,
          "filter":true , 
          "disable":true,
          "field": "phoneNumber",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "filter":true  
        },
        {
          "name": "speciality",
          "type": "text",
          "placeholder": "Speciality",
          "label": "Speciality",
          "width": "90px",
          "header": "Speciality",
          "derivedValue": "speciality=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "id": "speciality",
          "disable":true,
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "true",
          "controllerId": null,
          "textAlign": "Center",
          "show": true,
          "filter":true , 
          "field": "speciality",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "filter":true  
        },
        {
          "name": "Npi",
          "type": "text",
          "placeholder": "NPI",
          "label": "NPI",
          "width": "90px",
          "header": "NPI",
          "derivedValue": "Npi=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "disable":true,
          "id": "Npi",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "true",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "true",
          "controllerId": null,
          "textAlign": "Center",
          "show": true,
          "filter":true , 
          "field": "Npi",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "filter":true  
        },
        {
          "name": "fax",
          "type": "text",
          "placeholder": "Fax",
          "label": "Fax",
          "width": "150px",
          "header": "Fax",
          "derivedValue": "fax=undefined",
          "capitalizeTableText": false,
          "sortable": true,
          "actions": [],
          "actionsNumber": [],
          "disable":true,
          "id": "fax",
          "displayinaddForm": "true",
          "displayineditForm": "true",
          "displayinlist": "true",
          "isFieldRequired": "false",
          "required": false,
          "displayOptionsInActions": false,
          "globalSearchField": "true",
          "controllerId": null,
          "textAlign": "Center",
          "show": true,
          "filter":true , 
          "field": "fax",
          "showOrHideFields": [],
          "mobile": true,
          "displayInSettings": true,
          "filter":true  
        },
  ]);
  }

  submit = async (item) => {
    this.setState({ isOpenFormModal: true })
    await this.formModalRef.getRowData(item, 'edit');
    console.log("Submit Button in sode          ")
  }

  getAppointmentsData = (filter) => {    
    if(this.dataTableRef){      
      this.dataTableRef.getDataFromServer('','',filter,true);
    }else {
      console.log('testtttttttttttttttttttttttttttttttttttttttttttttttttttttttt',this.dataTableRef);
    }
 }

  getMobileTableFields = () => {
    let data = [{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"name","type":"text","placeholder":"Name","label":"Name","header":"Name","width":110,"id":"name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","controllerName":null,"fieldType":"Link","textAlign":"Center","globalSearchField":"true","show":true,"field":"name","mobile":true,"displayInSettings":true},{"name":"createdBy","type":"relateAutoComplete","placeholder":"CreatedBy","label":"CreatedBy","width":90,"disabled":true,"header":"CreatedBy","derivedValue":"createdBy=undefined","actions":[],"actionsNumber":[],"id":"createdBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"createdBy","mobile":true,"displayInSettings":true},{"name":"updatedBy","type":"relateAutoComplete","placeholder":"UpdatedBy","label":"UpdatedBy","width":90,"header":"UpdatedBy","derivedValue":"updatedBy=undefined","actions":[],"actionsNumber":[],"id":"updatedBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","disabled":true,"fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"updatedBy","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true}]

    return data;
  };
  closeFormModal = async () => {
    this.setState({
      isOpenFormModal: false,
    })
  }
  // submit1 = item => {
  //   let x = appointmentssFields
  //   let objappointmentss = {}

  //   objappointmentss["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objappointmentss[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objappointmentss,
  //     newFormFields: formFields
  //   });
  // }
  
  cancelReset = async (type) => {
    this.setState({
      openNewUserModal: false
    });
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };
  saveDataToServer = async (item, field, value) => {
    // console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAa", item, field, value)
    let body = item[0]
    body[field] = value
    let userBody = Object.assign({}, body);
    this.setState({
      isLoading: true
    });
    if (body) {
      let method, apiUrl;
      method = 'PUT';
      apiUrl = `${apiCalls.appointmentss}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, 'success');

          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, 'error');
          }
          this.setState({
            isLoading: false
          });
        }).catch((err) => {
          return err;
        });
    } else {
      return;
    }
  }
  render() {
    return (
      <div>
        <AppointmentDashboard 
        getAppointmentsData={this.getAppointmentsData} />
        <div className='my-4'></div>
        <DataTables
          {...this.props}
          onRef={ref => (this.dataTableRef = ref)}
          // MobileTableFields={this.getMobileTableFields}
          // getTableFields={this.getTableFields}
          // formFields={this.getFormFields}
          // 
editRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
deleteRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
viewRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
exportRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
sample={true}
          // globalSearch={'Display Name/Email'}
          // type='Appointmentss'
          // apiUrl={apiCalls.Appointmentss}
          getTableFields={this.getTableFields}
          formFields={this.getFormFields}
          // exportRequried={true}

          printRequried={true}
          actionsTypes={[
            {
              'name': 'Delete',
              "options": [
                { 'label': 'Delete', 'value': 'Delete', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": true, },
              ]
            },
            
            // {
            //   'name': 'Block',
            //   "options": [
            //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'ResetPassword',
            //   "options": [
            //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'Submit',
            //   'action': this.submit,
            //   "options": [
            //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
            //   ]
            // },
            // {
            //   name: "newModel",
            //   action: this.submit1,
            //   options: [
            //     { label: "newModel", value: "newModel", show: true, multiple: false }
            //   ]
            // }
            
          ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={true}
          exportToCsv={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          sampleFilePath={filePath.Appointmentss}
          setData={this.setData}
          editSelectedRecord={this.state.editSelectedRecord}
          addSelectedRecord={this.state.addSelectedRecord}
          viewSelectedRecord={this.state.viewSelectedRecord}
          globalSearch={'name'}
          type='Appointments'
          routeTo={apiCalls.Appointmentss}
          displayViewOfForm='screen'
          apiResponseKey={apiCalls.appointmentss}
          apiUrl={apiCalls.Appointmentss}
          enableEditRowMode={true}

        />
        {this.state.isOpenFormModal ? (
          <FormModal
            onRef={(ref) => (this.formModalRef = ref)}
            formType="edit"
            openFormModal={this.state.isOpenFormModal}
            formFields={this.props.formFields}
          />

        ) : null}
        {this.state.openNewUserModal ? (
          <NewUserModal
            openNewUserModal={this.state.openNewUserModal}
            cancelReset={this.cancelReset}
            item={this.state.item}
            newFormFields={this.state.newFormFields}
            recordId={this.state.item._id}
            entityType="appointmentss"
            apiUrl={apiCalls.Appointmentss}
          />
        ) : null}
      </div>
    );
  }
}